/** Ticket-service page copy, resolved by the existing translator. */
export const TICKET_SERVICE_PAGES: Record<string, [string, string, string]> = {
  'ts.home.title': ['查詢票券', 'Ticket services', 'チケットサービス'],
  'ts.home.desc': [
    '查詢航班資訊，或辦理已購票券的退票。',
    'View your sailing or request a ticket refund.',
    '便の確認や購入済みチケットの払い戻しはこちら。',
  ],
  'ts.scan.title': [
    '請掃描票券 QR Code',
    'Scan your ticket QR code',
    'チケットのQRコードをスキャン',
  ],
  'ts.scan.desc': [
    '請出示原票券 QR Code，查詢航班時間與登船資訊。',
    'Use your original ticket to view sailing and boarding details.',
    '元のチケットで便と乗船情報を確認します。',
  ],
  'ts.loading.title': ['正在確認並查詢票券', 'Looking up your ticket', 'チケットを確認中'],
  'ts.loading.desc': [
    '請稍候，正在取得最新資訊。',
    'Please wait while the details load.',
    '情報の読み込みをお待ちください。',
  ],
  'ts.not-found.title': ['目前無法辨識這張票券', 'Ticket not found', 'チケットを確認できません'],
  'ts.not-found.desc': [
    '請確認使用的是本次購票取得的票券。',
    'Please check that you are using the original ticket.',
    '購入時のチケットをご確認ください。',
  ],
  'ts.flight.title': ['我的航班', 'My sailing', 'ご利用便'],
  'ts.flight.desc': [
    '以下是這張票券對應的航班與登船資訊。',
    'Your sailing and boarding information.',
    'このチケットの便・乗船情報です。',
  ],
  'ts.cancelled.title': ['你的航班已停航', 'Your sailing is cancelled', 'ご利用便は欠航です'],
  'ts.cancelled.desc': [
    '因天候因素暫停航行，為維護旅客安全，本班次停止服務。',
    'This sailing is cancelled due to weather for passenger safety.',
    '悪天候により、安全のため欠航となりました。',
  ],
  'ts.quote.title': ['確認退票金額', 'Review your refund', '払い戻し金額の確認'],
  'ts.quote.desc': [
    '請確認金額與票券，再送出退票申請。',
    'Review the ticket and amount before submitting.',
    'チケットと金額をご確認のうえ申請してください。',
  ],
  'ts.ineligible.title': [
    '這張票無法自助退票',
    'Self-service refund unavailable',
    '端末で払い戻しできません',
  ],
  'ts.ineligible.desc': [
    '已超過自助退票期限，請攜帶票券與購票證明至服務櫃檯。',
    'The self-service deadline has passed. Bring your ticket and proof of purchase to the desk.',
    'セルフ払い戻し期限を過ぎています。チケットと購入証明を窓口へ。',
  ],
  'ts.package.title': ['套票請由櫃檯協助', 'Package ticket assistance', 'セット券は窓口へ'],
  'ts.package.desc': [
    '套票包含多段活動，需由現場人員確認整組退票安排。',
    'Staff will review the complete package and refund arrangements.',
    'セット券全体の払い戻しについてスタッフが確認します。',
  ],
  'ts.submitting.title': ['正在送出退票申請', 'Submitting your request', '払い戻し申請を送信中'],
  'ts.submitting.desc': [
    '請稍候，正在確認受理結果。',
    'Please wait for confirmation.',
    '受付結果を確認しています。',
  ],
  'ts.accepted.title': [
    '退票申請已受理',
    'Refund request accepted',
    '払い戻し申請を受け付けました',
  ],
  'ts.accepted.desc': [
    '請保留申請編號，方便後續查詢。',
    'Keep the reference number to check progress later.',
    '照会のため申請番号をお控えください。',
  ],
  'ts.processing.title': ['退票處理中', 'Refund processing', '払い戻し処理中'],
  'ts.processing.desc': [
    '款項尚未確認退回，可稍後再查詢進度。',
    'The refund has not yet been confirmed. Check again later.',
    '返金はまだ確認されていません。後ほどご確認ください。',
  ],
  'ts.allowance.title': [
    '款項已退回，折讓處理中',
    'Payment refunded; invoice adjustment pending',
    '返金済み・請求書調整中',
  ],
  'ts.allowance.desc': [
    '金流端已確認退款，實際入帳時間依付款機構作業。',
    'The provider confirmed the refund. Posting time depends on your payment provider.',
    '決済会社が返金を確認しました。着金時期は決済会社によります。',
  ],
  'ts.complete.title': [
    '退款與發票折讓已完成',
    'Refund and invoice adjustment complete',
    '返金と請求書調整が完了しました',
  ],
  'ts.complete.desc': [
    '票券已作廢，無法再次使用。',
    'This ticket has been voided and cannot be used again.',
    'このチケットは無効となり、再利用できません。',
  ],
  'ts.manual.title': [
    '這筆退票需要人員協助',
    'Staff assistance required',
    'スタッフの対応が必要です',
  ],
  'ts.manual.desc': [
    '款項已確認退款，發票折讓異常需由服務人員協助。',
    'Payment is refunded, but the invoice adjustment needs staff assistance.',
    '返金は確認済みですが、請求書調整にはスタッフの対応が必要です。',
  ],
  'ts.uncertain.title': [
    '尚未確認申請結果',
    'Request outcome not yet confirmed',
    '申請結果を確認できません',
  ],
  'ts.uncertain.desc': [
    '剛才的退票可能已被受理，請勿再次建立新的申請。',
    'Your request may have been accepted. Do not create a new request.',
    '申請が受理されている可能性があります。再申請はお控えください。',
  ],
  'ts.network.title': ['目前無法連線查詢', 'Unable to connect', '接続できません'],
  'ts.network.desc': [
    '請稍後重試，或向現場人員尋求協助。',
    'Try again later or ask staff for help.',
    '後ほど再試行するか、スタッフにお尋ねください。',
  ],
  'ts.idle.title': ['還需要繼續操作嗎？', 'Would you like to continue?', '操作を続けますか？'],
  'ts.idle.desc': [
    '為保護你的資料，系統即將清除本次查詢並返回首頁。',
    'For your privacy, this session will be cleared and the home screen will open.',
    '個人情報保護のため、照会を終了してホームに戻ります。',
  ],
  'ts.help.introTitle': ['服務人員將協助你', 'Our staff can help', 'スタッフがお手伝いします'],
  'ts.help.introLine1': [
    '找不到票券、套票退票或退款疑問，',
    'For missing tickets, package refunds or refund questions,',
    'チケットが見つからない場合や、セット券の払い戻し・返金に関するご質問は、',
  ],
  'ts.help.introLine2': [
    '請向現場服務人員出示相關資料。',
    'please show the relevant details to our on-site staff.',
    '関連資料を現場のスタッフにご提示ください。',
  ],
  'ts.help.context': ['現場協助', 'Staff assistance', '窓口サポート'],
  'ts.help.title': ['現場服務協助', 'On-site assistance', '窓口でのご案内'],
  'ts.help.desc': [
    '請攜帶票券或申請編號前往服務櫃檯。',
    'Bring your ticket or refund reference to the service desk.',
    'チケットまたは申請番号を窓口にお持ちください。',
  ],
  'ts.notice.title': ['退票服務說明', 'Refund service information', '払い戻しのご案内'],
  'ts.notice.desc': [
    '確認資訊後，再安心辦理。',
    'Review the information before proceeding.',
    '内容をご確認のうえお手続きください。',
  ],
  'ts.failed.title': [
    '退款未成功，請洽服務人員',
    'Refund unsuccessful; please ask staff',
    '返金未完了・スタッフにご相談ください',
  ],
  'ts.failed.desc': [
    '款項尚未退回。請勿重複申請，由服務人員協助確認。',
    'Payment has not been returned. Please ask staff instead of submitting again.',
    '返金されていません。再申請せずスタッフにご相談ください。',
  ],
  'ts.changed.title': ['退票金額已更新', 'Refund amount updated', '払い戻し金額が変更されました'],
  'ts.changed.desc': [
    '等待期間適用費用有所變動，請再次確認最新金額。',
    'The applicable fees changed. Please review the new amount.',
    '適用料金が変更されました。最新の金額をご確認ください。',
  ],
  'ts.refund-scan.title': [
    '請掃描要退票的票券',
    'Scan the ticket to refund',
    '払い戻すチケットをスキャン',
  ],
  'ts.refund-scan.desc': [
    '出示原票券 QR Code，先查看退票資格與預估金額。',
    'Use the original QR code to review eligibility and the estimated refund.',
    '元のQRコードで払い戻しの可否と予定金額を確認します。',
  ],
  'ts.used.title': ['這張票券已使用', 'This ticket has been used', 'このチケットは使用済みです'],
  'ts.used.desc': [
    '無法再次登船或自助退票。若對紀錄有疑問，請洽現場人員。',
    'It cannot be used again or refunded here. Ask staff if the record seems incorrect.',
    '再乗船・セルフ払い戻しはできません。記録に疑問がある場合はスタッフへ。',
  ],
  'ts.refund-not-found.title': [
    '找不到這筆退票申請',
    'Refund request not found',
    '申請が見つかりません',
  ],
  'ts.refund-not-found.checkTicket': [
    '請確認掃描的是要查詢的原票券，',
    'Check that you scanned the correct original ticket,',
    '照会する元のチケットを確認し、',
  ],
  'ts.refund-not-found.rescanHint': [
    '或重新掃描原票券。',
    'or scan the original ticket again.',
    '必要に応じて再スキャンしてください。',
  ],
  'ts.refund-not-found.desc': [
    '請確認掃描的是要查詢的原票券，或重新掃描原票券。',
    'Check that you scanned the correct original ticket, or scan it again.',
    '照会する元のチケットを確認し、必要に応じて再スキャンしてください。',
  ],
  'ts.quote-initial.title': ['確認退票金額', 'Review your refund', '払い戻し金額の確認'],
  'ts.quote-initial.desc': [
    '請先選擇退票原因，並勾選下方同意事項。',
    'Select a reason and confirm your agreement below.',
    '理由を選び、下の同意事項を確認してください。',
  ],
};
